import React from "react";
import { useTranslation } from "react-i18next";

const iconCls = "w-6 h-6";
const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

const FEATURES = [
  {
    key: "autodj",
    color: "text-purple-600 bg-purple-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M12 3v18" /><circle cx="12" cy="12" r="9" /><path d="M8 12a4 4 0 0 1 8 0" /></svg>),
  },
  {
    key: "upload",
    color: "text-pink-600 bg-pink-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M12 16V4m0 0l-4 4m4-4l4 4" /><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" /></svg>),
  },
  {
    key: "schedule",
    color: "text-blue-600 bg-blue-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18M8 2v4M16 2v4M12 13v3" /></svg>),
  },
  {
    key: "live",
    color: "text-red-600 bg-red-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></svg>),
  },
  {
    key: "stats",
    color: "text-emerald-600 bg-emerald-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></svg>),
  },
  {
    key: "mobile",
    color: "text-amber-600 bg-amber-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></svg>),
  },
  {
    key: "podcasts",
    color: "text-indigo-600 bg-indigo-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><circle cx="12" cy="9" r="4" /><path d="M12 13v5m-3 3h6" /><path d="M5 9a7 7 0 0 1 14 0" /></svg>),
  },
  {
    key: "embed",
    color: "text-cyan-600 bg-cyan-100",
    icon: (<svg viewBox="0 0 24 24" className={iconCls} {...stroke}><path d="M8 9l-3 3 3 3M16 9l3 3-3 3M13 6l-2 12" /></svg>),
  },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section id="features" className="bg-white py-20 px-4 scroll-mt-24">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">{t("features.title")}</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">{t("features.subtitle")}</p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((f) => (
            <div
              key={f.key}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm p-6 hover:shadow-lg hover:-translate-y-1 transition"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${f.color}`}>
                {f.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1.5">{t(`features.${f.key}.title`)}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t(`features.${f.key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
